webpackJsonp([35783957827783],{

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ems-home-services-logo-lg.c7941d95.png";

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _emsHomeServicesLogoLg = __webpack_require__(138);
	
	var _emsHomeServicesLogoLg2 = _interopRequireDefault(_emsHomeServicesLogoLg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Header.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { id: 'header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'inner' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'image fit', style: {
	                            maxWidth: 600,
	                            marginTop: 0,
	                            marginBottom: 0,
	                            marginLeft: 'auto',
	                            marginRight: 'auto'
	                        } },
	                    _react2.default.createElement(_gatsbyImage2.default, {
	                        className: '',
	                        sizes: this.props.headerImage.sizes,
	                        alt: 'EMS Home Services, HVAC Services, Austin TX'
	                    })
	                ),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Residential and Commercial HVAC ',
	                    _react2.default.createElement('br', null),
	                    'Services in Austin, TX ',
	                    _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'actions' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '#replace', className: 'button scrolly' },
	                            'Replace'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '#repair', className: 'button scrolly' },
	                            'Repair'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '#maintain', className: 'button scrolly' },
	                            'Maintain'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(29);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(89);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ServicePlanSummary = __webpack_require__(63);
	
	var _ServicePlanSummary2 = _interopRequireDefault(_ServicePlanSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = function (_React$Component) {
	    _inherits(Homepage, _React$Component);
	
	    function Homepage() {
	        _classCallCheck(this, Homepage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Homepage.prototype.componentDidMount = function componentDidMount() {
	        this.props.history.listen(function (_ref) {
	            var hash = _ref.hash;
	
	            if (hash) {
	                var section = document.getElementById(hash.replace('#', ''));
	                if (!!section) {
	                    section.scrollIntoView();
	                    return;
	                }
	            }
	            window.scrollTo(0, 0);
	        });
	    };
	
	    Homepage.prototype.render = function render() {
	        var siteTitle = this.props.data.site.siteMetadata.title;
	        // const servicePlans = this.props.data.servicePlans.edges
	        //     .map(i => {
	        //         return i.node;
	        //     })
	        //     .sort((a, b) => {
	        //         return a.sortOrder - b.sortOrder;
	        //     });
	
	        var imageSizes = {
	            bronze: this.props.data.bronzeImage,
	            gold: this.props.data.goldImage,
	            platinum: this.props.data.platinumImage
	        };
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { title: siteTitle }),
	            _react2.default.createElement(
	                "section",
	                { id: "contact", className: "cta-top" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "grid-wrapper" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-4 prompt-text" },
	                        _react2.default.createElement(
	                            "h2",
	                            null,
	                            "Need service now?"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Submit a service request, or request a callback."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-8 action-buttons" },
	                        _react2.default.createElement(
	                            "p",
	                            { className: "phone-number" },
	                            _react2.default.createElement(
	                                "a",
	                                { href: "tel:+15128042500" },
	                                "512-804-2500"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            { className: "actions uniform" },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "a",
	                                    { href: "/service-request", className: "button special" },
	                                    "Service Request"
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_Header2.default, { headerImage: this.props.data.headerImage }),
	            _react2.default.createElement(
	                "section",
	                { id: "replace", className: "main style1" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "grid-wrapper" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-6" },
	                        _react2.default.createElement(
	                            "header",
	                            { className: "major" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                "Time to replace?"
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Our HVAC experts can find the solution for you"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Our complete line of air conditioners are priced to help add comfort to your budget. And that\u2019s only the beginning. We want you to smile every time you open your utility bill, so we design energy efficient technology into our systems.  With lifetime compressor limited warranties and 10 year parts limited warranties, we will make sure your new system will run perfectly for years to come."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-6" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "image fit" },
	                            _react2.default.createElement(_gatsbyImage2.default, {
	                                className: "",
	                                sizes: this.props.data.replaceImage.sizes,
	                                alt: "EMS Home Services, HVAC Services, Austin TX"
	                            })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "section",
	                { id: "repair", className: "main style2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "grid-wrapper" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-6" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "image fit" },
	                            _react2.default.createElement(_gatsbyImage2.default, {
	                                className: "",
	                                sizes: this.props.data.repairImage.sizes,
	                                alt: "EMS Home Services, HVAC Services, Austin TX"
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-6" },
	                        _react2.default.createElement(
	                            "header",
	                            { className: "major" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                "Sometimes things break..."
	                            ),
	                            _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Our team of experienced technicians are the best in the business"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "With decades of experience our service technicians can get you out of the tightest of jams.  Our experienced staff will make real world suggestions to you regardinging the maintenance or replacment of your equipment.  Their job is to make sure your system runs at peak performance at all times without break downs."
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Homepage;
	}(_react2.default.Component);
	
	Homepage.propTypes = {
	    route: _react2.default.PropTypes.object
	};
	
	exports.default = Homepage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-784690e7c5ea6fd67741.js